// extracted by mini-css-extract-plugin
export default {"generalConditionL1":"HealthL1_generalConditionL1__PVNEF","smallPiegraph":"HealthL1_smallPiegraph__GR88Q"};